<template>
<div class="content-center" id="login">
  <b-col>
    <div class="mt-3" v-if="browser">
      <b-alert show variant="danger">
        <h2 class="alert-heading">Atenção!</h2>
        <p>
          Verificamos que o navegador utilizado é o <b>{{result || 'detecting…'}}</b>, esta aplicação só é compatível com a versão 18 ou superior, por favor, seguir os seguintes passos para
          atualizar seu navegador:
        </p>
        <p>
          Entrar em <b>"Configurações"</b>, após isso <b>"Atualizações  segurança"</b>, verificar se há atualizações disponíveis (Windows update), clicar em <b>"Verificar se há atualizações"</b> e aguardar a instalação.
          Talvez seja necessário repetir essa operação algumas vezes até que não haja mais nenhuma atualização disponível para download.
        </p>
        <!--<p>{{details || 'n/a'}}</p>-->
        <hr>
        <p class="mb-0">
          <b>Ou então para melhor uso da aplicação, recomendamos o uso do Chrome, Firefox ou Safari.</b>
        </p>
      </b-alert>
    </div>
    <b-card-group>
      <b-card class="bradius content-login">
        <img src="@/assets/gosalesVertical.png" alt="" class="mb-5 mt-5" id="logoGoSales">
        <b-card-text   class="content-center" @submit.prevent="listarEmpresas">
          <div v-if="esqueciASenha" class="content-center itens">
            <b-input-group class="mb-2 col-10">
              <b-input-group-prepend>
                <span class="input-group-text"><i class="fa fa-user"></i></span>
              </b-input-group-prepend>
              <b-form-input type="text" placeholder="Email" size="sm" v-validate="'required|email'"  :class="{'input': true, 'invalidLogin': errors.has('email')}" name="email" v-model="authUser.usuario"></b-form-input>
            </b-input-group>
            <span v-show="errors.has('email')" class="invalidLogin">{{ errors.first('email') }}</span>
            <b-input-group class="col-10">
              <b-input-group-prepend>
                <span class="input-group-text"><i class="fas fa-unlock-alt"></i></span>
              </b-input-group-prepend>
              <b-form-input type="password" placeholder="Senha" size="sm" v-validate="'required|min:4'" :class="{'input': true, 'invalidLogin': errors.has('senha')}" name="senha"  v-model="authUser.senha"></b-form-input>
            </b-input-group>
            <span v-show="errors.has('senha')" class="invalidLogin">{{ errors.first('senha') }}</span>
            <div>
              <b-button variant="light" :disabled="disabled || authUser.senha.length < 4" class="mt-3 btn-continuar" size="sm" v-on:click="listarEmpresas()">
                <b-spinner v-if="isLoading" small class="mr-2" label="Small Spinner"/>
                <span>Continuar</span>
              </b-button>
              <div @submit="logar" v-show="escolhaEmpresas" class="mt-2 mb-2">
                <div class="selecionar-empresa">Selecionar empresa:</div>
                <div style="border-top: 1px solid rgba(255,255,255,0.36)"></div>
                <b-card>
                  <swiper :options="swiperOption">
                    <swiper-slide  v-for="empresa in empresas" :key="empresa.id">
                      <img :src="empresa.urlLogoPositivo" class="mr-2 ml-2 empresas" v-on:click="logar(empresa)" alt=""/>
                    </swiper-slide>
                  </swiper>
                </b-card>
              </div>
            </div>
            <b-button variant="outline-light" size="sm" class="mt-2" style="width: 180px" v-on:click="recuperaSenha()">Esqueci minha senha</b-button>
          </div>
          <div v-else="esqueciASenha"  class="content-center itens">
            <b-input-group class="mb-5 col-10">
              <b-input-group-prepend>
                <span class="input-group-text"><i class="fas fa-envelope"></i></span>
              </b-input-group-prepend>
              <b-form-input type="text" placeholder="Email" size="sm" v-validate="'required|email'"  :class="{'input': true, 'invalidLogin': errors.has('email')}" name="email"></b-form-input>
            </b-input-group>
            <span v-show="errors.has('email')" class="invalidLogin">{{ errors.first('email') }}</span>
              <b-button variant="outline-light" size="sm" class="col-3" v-on:click="cancelar">Cancelar</b-button>
              <b-button variant="outline-light" size="sm" class="col-3">Enviar</b-button>
          </div>
        </b-card-text>
      </b-card>
      <toast-vue :idToast="idToastItem" :variant="variant" :titleMsg="titleMsg" :message="message"></toast-vue>
    </b-card-group>
  </b-col>
</div>
</template>
<script>
  import login from '@/services/login'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import ToastVue from '@/components/layouts/toastVue'

  export default {
    name: 'Login',
    data () {
      return {
        idToastItem: 'my-toast-item',
        titleMsg: '',
        message: '',
        variant: '',
        escolhaEmpresas: false,
        esqueciASenha: true,
        isLoading: false,
        disabled: false,
        authUser: {
          usuario: '',
          senha: '',
          identificador: ''
        },
        empresas: [],
        dadosLogin: {
          identificador: '',
          usuario: '',
          senha: ''
        },
        browser: false,
        details: '',
        result: '',
        swiperOption: {
          slidesPerView: 2,
          spaceBetween: 3,
          freeMode: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        }
        // message: {
        //   idToast: 'my-toast',
        //   titleMsg: '',
        //   message: '',
        //   variant: ''
        // }
      }
    },
    components: {
      swiper,
      swiperSlide,
      ToastVue
    },
    props: ['status', 'cor', 'logo', 'corSelecionado'],
    created () {
      this.verificaBrowser()
    },
    methods: {
      // showMessage: function (message, title, variantColor) {
      //   this.message = message
      //   this.titleMsg = title
      //   this.variant = variantColor
      //   this.$bvToast.show(this.message.idToast)
      // },
      showMessage: function (message, title, variantColor) {
        this.message = message
        this.titleMsg = title
        this.variant = variantColor
        this.$bvToast.show('my-toast-item')
      },
      mudarCorPSelecionada () {
        const payload = {
          corSelecionado: {'background-color': `#${localStorage.getItem('corSelecionado')}`}
        }
        this.$store.commit('CHANGE_COLOR_SELECIONADO', payload)
      },
      mudarCor () {
        const payload = {
          cor: {'background-color': `#${localStorage.getItem('corApp')}`}
        }
        this.$store.commit('CHANGE_COLOR', payload)
      },
      mudarLogo () {
        const payload = {
          empresa: localStorage.getItem('urlLogoPositivo')
        }
        this.$store.commit('CHANGE_LOGO', payload)
      },
      listarEmpresas: function () {
        this.isLoading = true
        this.disabled = true
        login.listarEmpresas(this.authUser).then(response => {
          this.isLoading = false
          this.empresas = response.data.empresas
          if (this.empresas.length === 0) {
            alert(response.data.acesso.mensagem)
          } else if (this.empresas.length === 1) {
            this.logar(this.empresas[0])
          }
          this.escolhaEmpresas = true
        }).catch(e => {
          this.disabled = false
          this.isLoading = false
          this.showMessage(e.response.data.acesso.mensagem, 'Atenção', 'danger')
        })
      },
      logar: function (empresa) {
        // console.log('chamou logar ' + new Date())
        this.authUser.identificador = empresa.identificador
        login.logar(this.authUser).then(response => {
          // console.log(JSON.stringify(response))
          if (response.data.acesso.autenticado) {
            localStorage.setItem('dadosAcesso', JSON.stringify(response.data.dadosAcesso))
            localStorage.setItem('representanteSelecionado', JSON.stringify(response.data.dadosAcesso.representante))
            localStorage.setItem('representantesLogin', JSON.stringify(response.data.dadosAcesso.representante.representantes))
            localStorage.setItem('empresaLogada', JSON.stringify(response.data.empresa))
            let cor = response.data.empresa.appConfig.cores.corApp
            localStorage.setItem('corApp', cor)
            let corSelecionado = response.data.empresa.appConfig.cores.corMenuPrincipalSelecionado
            localStorage.setItem('corSelecionado', corSelecionado)
            let logo = response.data.empresa.urlLogoPositivo
            localStorage.setItem('urlLogoPositivo', logo)
            let accessToken = response.data.acesso.token
            localStorage.setItem('token', accessToken)
            this.mudarCor()
            this.mudarLogo()
            this.mudarCorPSelecionada()
            this.$router.push('/Home')
            this.$forceUpdate()
          }
        }).catch(error => {
         // this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger')
          if (typeof error.response.data.mensagem === 'string') {
            let message = JSON.parse(error.response.data.mensagem)
            this.showMessage(message.acesso.mensagem + ' - Por favor, entre em contato com o suporte', 'Atenção', 'danger')
          } else {
            this.showMessage(error.response.data.mensagem, 'Atenção', 'danger')
          }

          // alert('erro login ' + error.response.data)

          this.errors = error.response.data.acesso.mensagem
        })
      },
      recuperaSenha: function () {
        this.esqueciASenha = false
      },
      cancelar: function () {
        this.esqueciASenha = true
      },
      verificaBrowser: function () {
        // Get IE or Edge browser version
        let version = detectEdge()

        if (version <= 17) {
          this.browser = true
          this.result = 'Edge na versão ' + version
        }

        // add details to debug result
        this.details = window.navigator.userAgent

        function detectEdge () {
          let ua = window.navigator.userAgent

          let edge = ua.indexOf('Edge/')
          if (edge > 0) {
            // Edge (IE 12+) => return version number
            return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10)
          }
          // other browser
          this.browser = false
          return false
        }
      }
    }
  }
</script>
<style scoped>
  #login {
    height: 100%;
    min-height: 100vh;
    display: flex;
    align-items: center;
    overflow-y: hidden;
    background: #4d005a;
    background: -moz-linear-gradient(top, #4d005a 0%, #5e2576 100%);
    background: -webkit-gradient(left top, left bottom, color-stop(0%, #4d005a), color-stop(100%, #5e2576));
    background: -webkit-linear-gradient(top, #4d005a 0%, #5e2576 100%);
    background: -o-linear-gradient(top, #4d005a 0%, #5e2576 100%);
    background: -ms-linear-gradient(top, #4d005a 0%, #5e2576 100%);
    background: linear-gradient(to bottom, #4d005a 0%, #5e2576 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#4d005a', endColorstr='#5e2576', GradientType=0 );
  }
  .content-login{
    border-radius: 0 !important;
    /* background-image: linear-gradient(to bottom, #40005c, #490064, #53016c, #5d0174, #67017c, #700186, #790090, #82009a, #8c01a8, #9603b7, #a005c6, #aa09d6);
    background-image: url('~@/assets/splashGoSalesSemLogo.jpg');
    background-repeat: no-repeat;
    background-size: 100%; */
  }
  img#logoGoSales {
    width: 30%;
  }
  label{
    color: #ffffff;
    font-family: 'Roboto', sans-serif;
    font-weight: 600;
    float: left;
  }
  .empresas{
    border: 1px solid #f8f9fa8c;
    border-radius: 10%;
    max-width: 70%;
    max-height: 38px;
    padding: 5px;
  }
  .itens{
    height: 285px;
  }
  .lista-empresas{
    display: inline;
    height: 100px;
  }
  .card {
    background-color: transparent;
  }

  .btn-outline-light {
    border-color: rgba(248, 249, 250, 0.58);
  }
  .btn-continuar{
    max-width: 150px;
    color: #000000
  }
  /*.img-empresas{*/
    /*overflow: scroll;*/
    /*overflow-y: hidden;*/
    /*background-color: transparent;*/
    /*height: 90px;*/
  /*}*/
  .nobr {
    white-space: nowrap;
  }
  .selecionar-empresa{
    color: #c7c2c2;
    text-align: left;
    margin-top: 9px;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/templates/Login.vue